import React from "react";
import { Stack } from "@mui/material";
import styled from "styled-components";
import AssessmentIcon from "@mui/icons-material/Assessment";

const H2 = styled.h2`
    font-size: 22px;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const BorderedStack = styled(Stack)`
    border-radius: 14px;
    width: 100%;
`;

const BodyText = styled.p`
    font-size: 14px;
    font-weight: 300;
    margin: 0;
`;

const RepoViewPlaceholder = () => {
    return (
        <BorderedStack
            spacing={2}
            direction="column"
            justifyContent="center"
            alignItems="center"
            p={10}
            m={3}
        >
            <AssessmentIcon style={{ width: "100px", height: "auto", opacity: "0.3" }} />
            <Stack alignItems="center">
                <H2>Select a repo or a group of repos and view analytics</H2>
                <BodyText>You can select from one up to as many as needed repositories.</BodyText>
                <BodyText>
                    Selections of multiple repositories can be saved and recalled as groups.
                </BodyText>
            </Stack>
        </BorderedStack>
    );
};

export default RepoViewPlaceholder;
